import { render, staticRenderFns } from "./ui-product-list.vue?vue&type=template&id=054b093b&scoped=true&"
import script from "./ui-product-list.vue?vue&type=script&lang=js&"
export * from "./ui-product-list.vue?vue&type=script&lang=js&"
import style0 from "./ui-product-list.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ui-product-list.vue?vue&type=style&index=1&id=054b093b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054b093b",
  null
  
)

export default component.exports